export const renderVerificationCode = (code: string) => {
  if (!code) return null;
  return code.split('').map((digit: string, index: number) => (
    // eslint-disable-next-line react/no-array-index-key
    <p key={index} className="px-4 py-2 text-4xl rounded bg-elr-gray-100">
      {digit}
    </p>
  ));
};
